import React from 'react';
import classnames from 'classnames';
import styles from './dataProductCosts.module.scss';
import { getTimescaleText } from 'v2/utils/dataProductsUtils';
import { DataProduct } from 'v2/models';

interface DataProductCostProps {
  dataProduct: DataProduct;
}

const DataProductCosts = ({ dataProduct }: DataProductCostProps) => {
  return (
    <div>
      {dataProduct.costs.map((cost) => {
        return (
          <div
            className="mb-4"
            key={cost.id}
            data-testid={`cost_${cost.id}`}
            data-cy="dataset-cost-info-row"
          >
            <div className={classnames(styles.costsFields, 'mb-3')}>
              <span className="text-left" data-cy="dataset-cost-value">
                {cost.amount?.toFixed(2)} {cost.currency?.toUpperCase()}
              </span>
              <span
                className={classnames(styles.scaleTime, 'text-left')}
                data-cy="dataset-cost-period"
              >
                {cost.time_period ? getTimescaleText(cost.time_period) : ''}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DataProductCosts;
